@if (success()) {
  <span class="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl border text-[12px] font-semibold
               border-emerald-200 text-emerald-800 bg-emerald-50">
    <lucide-icon name="circle-check" class="h-3.5 w-3.5 shrink-0" />
    Desistimiento solicitado
  </span>
} @else if (isEligible()) {
  <button type="button"
          (click)="openModal($event)"
          class="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl border text-[12px] font-semibold transition-all duration-150 active:scale-[0.97] focus:outline-none border-slate-300 text-slate-800 bg-slate-50 hover:bg-slate-100">
    <lucide-icon name="file-text" class="h-3.5 w-3.5 shrink-0" />
    Ejercer desistimiento
  </button>
}

@if (modalOpen()) {
  <div
       (click)="closeModal()"
       class="fixed inset-0 z-[120] flex items-end sm:items-center justify-center px-4 pb-6 sm:pb-0 bg-slate-900/50 backdrop-blur-[1px]">
    <div
         (click)="$event.stopPropagation()"
         class="w-full max-w-md rounded-2xl border bg-white p-6 border-pale-gray shadow-tfr-sm">
      <div class="flex items-start justify-between gap-3 mb-4">
        <div>
          <h2 class="text-[17px] font-bold text-midnight-indigo">Ejercer desistimiento</h2>
          <p class="mt-1 text-[12px] text-steel-gray">
            {{ spaceName() }} · {{ formatDate()(booking().date) }}
          </p>
        </div>
        <button type="button"
                (click)="closeModal()"
                [disabled]="loading()"
                aria-label="Cerrar"
                class="h-8 w-8 flex items-center justify-center rounded-xl border border-pale-gray text-slate-blue shrink-0 disabled:opacity-50">
          <lucide-icon name="x" [size]="16" />
        </button>
      </div>

      <div class="space-y-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-[13px] leading-relaxed text-slate-800">
        <p>
          Esta solicitud registra tu intención de ejercer el derecho de desistimiento.
          <strong>No cancela automáticamente la reserva</strong> ni garantiza un reembolso inmediato.
        </p>
        <p>
          Nuestro equipo revisará la solicitud y te contactará por correo con la resolución.
          También puedes usar el
          <a href="/desistimiento" target="_blank" rel="noopener" class="text-action-blue hover:underline">formulario público</a>
          si lo prefieres.
        </p>
      </div>

      <label class="mt-5 flex items-start gap-3 cursor-pointer select-none">
        <input type="checkbox"
               class="mt-0.5 h-4 w-4 rounded border-pale-gray text-midnight-indigo focus:ring-midnight-indigo/30"
               [checked]="acknowledged()"
               (change)="acknowledged.set($any($event.target).checked)" />
        <span class="text-[12px] leading-snug text-slate-blue">
          Entiendo que esta solicitud queda pendiente de revisión y que deseo ejercer el desistimiento
          sobre esta reserva confirmada.
        </span>
      </label>

      @if (error(); as err) {
        <p class="mt-3 text-[12px] text-red-600">{{ err }}</p>
      }

      <div class="mt-6 flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
        <button type="button"
                (click)="closeModal()"
                [disabled]="loading()"
                class="rounded-xl border px-4 py-2.5 text-[13px] font-semibold border-pale-gray text-slate-blue disabled:opacity-50">
          Volver
        </button>
        <button type="button"
                (click)="confirmWithdrawal()"
                [disabled]="!acknowledged() || loading()"
                class="rounded-xl px-4 py-2.5 text-[13px] font-semibold text-white bg-midnight-indigo hover:brightness-110 disabled:opacity-40 disabled:cursor-not-allowed">
          @if (loading()) {
            Enviando&hellip;
          } @else {
            Confirmar solicitud
          }
        </button>
      </div>
    </div>
  </div>
}
